(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('network', {
                parent: 'app',
                url: '/my-network',
                redirectTo: 'my-connections',
                data: {
                    pageTitle: 'Axenteev | Mon Network',
                    authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/network/network.html',
                        controller: 'NetworkController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('my-connections', {
                parent: 'network',
                url: '/connections',
                data: {
                    pageTitle: 'Axenteev | Mon Network',
                    authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
                },
                views: {
                    'content@network': {
                        templateUrl: 'app/network/connections/my-connections.html'
                    }
                }
            })
            .state('contributions-menu', {
                parent: 'network',
                url: '/contributions',
                redirectTo: 'my-contributions-profile',
                data: {
                    pageTitle: 'Axenteev | Mes contributions',
                    authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
                },
                views: {
                    'content@network': {
                        templateUrl: 'app/network/contributions/contributions-menu.html'
                    }
                }
            })
            .state('contributions-pending-profile', {
                parent: 'network',
                url: '/contributions-pending',
                data: {
                    pageTitle: 'Axenteev | Mes contributions à valider',
                    authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
                },
                views: {
                    'content@network': {
                        templateUrl: 'app/network/contributions-pending/my-contributions-pending-profile.html'
                    }
                }
            })
            .state('homonyms-pending-profile', {
                parent: 'network',
                url: '/homonyms-pending',
                data: {
                    pageTitle: 'Axenteev | Mes homonymes à valider',
                    authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
                },
                views: {
                    'content@network': {
                        templateUrl: 'app/network/homonyms-pending/my-homonyms-pending-profile.html'
                    }
                }
            })
            .state('my-contributions-profile', {
                parent: 'contributions-menu',
                url: '/all',
                data: {
                    pageTitle: 'Axenteev | Mes contributions de profile',
                    authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
                },
                views: {
                    'content@contributions-menu': {
                        templateUrl: 'app/network/contributions/my-contributions-profile.html'
                    }
                }
            })
            .state('my-contributions-organisation', {
                parent: 'contributions-menu',
                url: '/all',
                data: {
                    pageTitle: "Axenteev | Mes contributions d'organisation",
                    authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
                },
                views: {
                    'content@contributions-menu': {
                        templateUrl: 'app/network/contributions/my-contributions-organisation.html'
                    }
                }
            })
            .state('contributions-later', {
                parent: 'contributions-menu',
                url: '/later',
                data: {
                    pageTitle: 'Axenteev | Contributions à modifier plus tard',
                    authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
                },
                views: {
                    'content@contributions-menu': {
                        templateUrl: 'app/network/contributions/contributions-later.html'
                    }
                }
            })
            .state('internal-network', {
                parent: 'network',
                url: '/sales',
                redirectTo: 'registered-sales',
                data: {
                    pageTitle: 'Axenteev | Mon Internal Network',
                    authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
                },
                views: {
                    'content@network': {
                        templateUrl: 'app/network/internal-network/sales-menu.html'
                    }
                }
            })
            .state('registered-sales', {
                parent: 'internal-network',
                url: '/registered',
                data: {
                    pageTitle: 'Axenteev | Mes commerciaux enregistrés',
                    authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
                },
                views: {
                    'content@internal-network': {
                        templateUrl: 'app/network/internal-network/registered-sales.html'
                    }
                }
            })
            .state('invited-sales', {
                parent: 'internal-network',
                url: '/invited',
                data: {
                    pageTitle: 'Axenteev | Mes commerciaux invités',
                    authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
                },
                views: {
                    'content@internal-network': {
                        templateUrl: 'app/network/internal-network/invited-sales.html'
                    }
                }
            })
            .state('archived-sales', {
                parent: 'internal-network',
                url: '/archived',
                data: {
                    pageTitle: 'Axenteev | Mon commerciaux archivés',
                    authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
                },
                views: {
                    'content@internal-network': {
                        templateUrl: 'app/network/internal-network/archived-sales.html'
                    }
                }
            })
    }
})();
